import React, { useContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import TFLogo from "../../Images/TFLogo.png";
import {
  FaBook,
  FaUser,
  FaCog,
  FaList,
  FaChartBar,
  FaBriefcase,
  FaRegFileAlt,
  FaSignOutAlt,
  FaProjectDiagram,
  FaFolderPlus 
} from "react-icons/fa";
import {
  MdCategory,
  MdOutlineLibraryBooks,
  MdOutlineDashboard,
  MdHomeFilled,
  MdMenuBook,
  MdAppRegistration,
} from "react-icons/md";
import { FaClipboardList } from "react-icons/fa";
import { VscTypeHierarchySub } from "react-icons/vsc";
import { GrUserWorker } from "react-icons/gr";
import { ThemeContext } from "../theme/ThemeProvider";
import { IconCashBanknoteFilled } from "@tabler/icons-react";
import { clearProfileData } from "../../common/redux/slices/userSlice";
import { Dashboard } from "../../common/components/Sidebar";

const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const themeContext = useContext(ThemeContext);
  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }
  const { isDarkMode } = themeContext;

  const handleLogout = () => {
    dispatch(clearProfileData());
  };

  const menuGroups = [
    {
      heading: "ANALYTICS",
      items: [
        {
          label: "Dashboard",
          icon: <MdOutlineDashboard />,
          onClick: () => navigate("/admin/dashboard"),
        },
        {
          label: "Performance",
          icon: <FaChartBar />,
          onClick: () => navigate("#"),
        },
        {
          label: "Projects",
          icon: <FaProjectDiagram />,
          onClick: () => navigate("/admin/project"),
        },
      ],
    },
    {
      heading: "ACCOUNT",
      items: [
        {
          label: "Expense ",
          icon: <MdOutlineLibraryBooks />,
          onClick: () => navigate("/admin/Expense"),
        },
        {
          label: "Donation ",
          icon: <FaBook />,
          onClick: () => navigate("/admin/DonationDetails"),
        },
        {
          label: "Donation Type Purpose",
          icon: <FaList />,
          onClick: () => navigate("/admin/DonationTypePurpose"),
        },
        {
          label: "Bank ",
          icon: <FaUser />,
          onClick: () => navigate("/admin/BankDetails"),
        },
        {
          label: "Bank Statement",
          icon: <IconCashBanknoteFilled />,
          onClick: () => navigate("/admin/BankStatement"),
        },
        
        {
          label: "Balance Transfer",
          icon: <MdCategory />,
          onClick: () => navigate("/admin/BalanceTransfer"),
        },
        {
          label: "Box",
          icon: <FaBriefcase />,
          onClick: () => navigate("/admin/box"),
        },
        {
          label: "Donation Type",
          icon: <FaBook />,
          onClick: () => navigate('/admin/DonationType'),
        },
        {
          label: "Purpose Type",
          icon: <FaBook />,
          onClick: () => navigate('/admin/PurposeType'),
        }
        
      ],
    },
    {
      heading: "EDUCATION",
      items: [
        {
          label: "Education Type",
          icon: <MdCategory />,
          onClick: () => navigate("/admin/EducationType"),
        },
        {
          label: "Course Type",
          icon: <VscTypeHierarchySub />,
          onClick: () => navigate("/admin/CourseType"),
        },
        {
          label: "Course",
          icon: <FaClipboardList />,
          onClick: () => navigate("/admin/Course"),
        },
        {
          label: "Course Offering",
          icon: <MdMenuBook />,
          onClick: () => navigate("/admin/CourseOffering"),
        },
        {
          label: "Registration",
          icon: <MdAppRegistration />,
          onClick: () => navigate("/admin/Registration"),
        },
        {
          label: "Batch",
          icon: <FaFolderPlus />,
          onClick: () => navigate("/admin/Batch"),
        },
        {
          label: "Employee",
          icon: <GrUserWorker />,
          onClick: () => navigate("/admin/Employee"),
        },
      ],
    },
    {
      heading: "CUSTOMIZATION",
      items: [
        {
          label: "Users",
          icon: <FaUser />,
          onClick: () => navigate("/admin/users"),
        },
        {
          label: "Taxonomies",
          icon: <FaCog />,
          onClick: () => navigate("/admin/taxinomies"),
        },
        {
          label: "Templates",
          icon: <FaRegFileAlt />,
          onClick: () => navigate("/admin/template"),
        },
        {
          label: "Home",
          icon: <MdHomeFilled />,
          onClick: () => navigate("/home"),
        },
        {
          label: "Logout",
          icon: <FaSignOutAlt />,
          onClick: () => handleLogout(),
        },    
      ],
    },
  ];

  return (
    <div className={`${isDarkMode ? "bg-globalBg" : "bg-[#ffff]"}`}>
  <div className=" h-screen shadow-md flex flex-row w-full md:gap-x-2 border-r">

    {/* Sidebar (Dashboard) */}
    <div className="relative z-20">
      <Dashboard menuGroups={menuGroups} logo={TFLogo} />
    </div>

    {/* Main Content */}
    <div
      className={`flex-1 h-full overflow-y-auto  relative z-10 md:z-30 ${
        isDarkMode ? "bg-globalBg" : "bg-[#ffff]"
      }`}
    >
      <Outlet />
    </div>
  </div>
</div>

  );
};

export default Sidebar;
